import { toDateOnlyString } from './dateOnly';

export const getLocale = (language) => (language === 'en' ? 'en-US' : 'es-CO');

export const formatCurrency = (value, language = 'es') => {
  const numericValue = Number(value || 0);

  return new Intl.NumberFormat(getLocale(language), {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
  }).format(numericValue);
};

export const formatNumber = (value, language = 'es') =>
  new Intl.NumberFormat(getLocale(language), {
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export const formatDate = (value, language = 'es') => {
  const dateOnly = toDateOnlyString(value);
  if (!dateOnly) return '-';
  const date = new Date(`${dateOnly}T00:00:00.000Z`);
  if (Number.isNaN(date.getTime())) return '-';

  return new Intl.DateTimeFormat(getLocale(language), {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
  }).format(date);
};

export const getApiErrorMessage = (response, fallback) =>
  response?.data?.message || response?.message || fallback;
